import { createFileRoute } from "@tanstack/react-router";
import DraaiboekHusselavond from "@/pages/DraaiboekHusselavond";

export const Route = createFileRoute("/draaiboek-husselavond")({
  head: () => ({
    meta: [
      { title: "Draaiboek husselavond: gratis stappenplan voor je tennisclub | De Hussel App" },
      { name: "description", content: "Een succesvolle husselavond organiseren? Met dit complete draaiboek — van bananen reserveren tot na-borrel — sla je niets over." },
      { property: "og:title", content: "Draaiboek husselavond: gratis stappenplan voor je tennisclub | De Hussel App" },
      { property: "og:description", content: "Een succesvolle husselavond organiseren? Met dit complete draaiboek — van bananen reserveren tot na-borrel — sla je niets over." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/draaiboek-husselavond" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/draaiboek-husselavond" }],
  }),
  component: DraaiboekHusselavond,
});
